import React from 'react';
import moment from 'moment';
import ButtonTableAction from "../../../../../../components/buttons/ButtonTableAction";
import {EventParticipation, EventParticipationFilters} from "../../../../../../app/models/EventParticipation";
import {momentParseDate} from "../../../../../../helpers";
import DefaultDataTable from "../../../../../../components/default/DefaultDataTable";
// import ChangeStatusEventParticipation from '../EventParticipationChangeStatus';

interface Props {
    eventParticipations: EventParticipation[];
    callbackSuccess?: () => void;
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: EventParticipationFilters;
    setFilter: (filter: EventParticipationFilters) => void;
    show?: (id: number) => void;

}

const EventParticipationDataTable = ({
    eventParticipations,
    totalRows,
    callbackSuccess,
    loading = false,
    edit,
    show,
    destroy,
    filter,
    setFilter,
}: Props) => {

    const defaultImage = "https://media.istockphoto.com/id/1354776450/vector/no-photo-available-vector-icon-default-image-symbol-picture-coming-soon-for-web-site-or.jpg?s=612x612&w=0&k=20&c=sE9bs1rjaBAZ5hO9WZ1JH_ItWjZaMih2zE9ig0GraWY=";

    const columns = [
        {
            name: 'Nombre',
            selector: (row: EventParticipation) => row?.participant?.user?.first_name,
            sortable: true,
            sortField: 'first_name',
        },
        {
            name: 'Apellido',
            selector: (row: EventParticipation) => row?.participant?.user?.last_name,
            sortable: true,
            sortField: 'last_name',
        },
        {
            name: 'Descripción',
            selector: (row: EventParticipation) => row?.participant?.job_position,
            sortable: true,
            sortField: 'job_description',
        },
        {
            name: 'Descripción',
            selector: (row: EventParticipation) => row?.is_attended ? 'Asistió' : 'Registrado',
            sortable: true,
            sortField: 'job_description',
        }
        // {
        //     name: 'Acciones',
        //     selector: (row: EventParticipation) => row?.id,
        //     cell: (row: EventParticipation) => (
        //         <div>
        //             {show && (
        //                 <ButtonTableAction
        //                     callbackFunction={() => show(row?.id ?? -1)}
        //                     classIcon={'mdi mdi-eye'}
        //                     colorIcon={'text-info'}
        //                     errorMessage={'No se puede mostrar este registro.'}
        //                     title={'Ver'}
        //                 />
        //             )}
        //             {edit && (
        //                 <ButtonTableAction
        //                     callbackFunction={() => edit(row.id ?? 0)}
        //                     classIcon={'mdi mdi-pencil'}
        //                     colorIcon={'text-warning'}
        //                     title={'Editar'}
        //                 />
        //             )}
        //             {destroy && (
        //                 <ButtonTableAction
        //                     callbackFunction={() => destroy(row.id ?? 0)}
        //                     classIcon={'mdi mdi-delete'}
        //                     colorIcon={'text-danger'}
        //                     title={'Eliminar'}
        //                 />
        //             )}
        //         </div>
        //     ),
        // },
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={eventParticipations}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default EventParticipationDataTable;
